export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/watercolor.ecd06d1.png";